module.exports = __webpack_public_path__ + "img/loginLogo.2251305d.png";